import * as React from 'react';

const ArchitechIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
    <defs>
      <clipPath id="a">
        <path
          d="m317.75 139-75.54 43.61a.58.58 0 0 1-.77-.16l-8.55-11.92a.59.59 0 0 1 .18-.85l75.55-43.62a.58.58 0 0 1 .77.17l8.55 11.92a.59.59 0 0 1-.19.85Z"
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
    </defs>
    <ellipse
      cx={250}
      cy={344.94}
      rx={226.35}
      ry={133.35}
      style={{
        fill: '#f5f5f5',
      }}
    />
    <path
      d="M370.17 274.7 180.59 384.16l-84.92-49.08 189.58-109.45 84.92 49.07zM409.16 380.21l-50.55 29.15a10.89 10.89 0 0 1-10.89 0l-71.31-41.17L339 332.08l70.14 40.49a4.41 4.41 0 0 1 .02 7.64Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <ellipse
      cx={291.69}
      cy={341.92}
      rx={50.31}
      ry={29.05}
      style={{
        fill: '#e0e0e0',
      }}
    />
    <ellipse
      cx={189.89}
      cy={424.2}
      rx={15.57}
      ry={9.17}
      style={{
        fill: '#e0e0e0',
      }}
    />
    <ellipse
      cx={111.91}
      cy={389.95}
      rx={43.71}
      ry={25.75}
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="m360.01 177.55-179.1 103.4-73.78-42.94 179.1-103.4 73.78 42.94z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m360.01 177.55-179.1 103.4-73.78-42.94 179.1-103.4 73.78 42.94z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="m349.6 177.53-168.67 97.39-48.19-28.05-4.55-2.65-10.65-6.2 10.65-6.14 4.55-2.63 153.48-88.61 63.38 36.89z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m129.75 245.13 51.17 29.78 156.47-90.33-51.17-29.79-156.47 90.34z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="m360.01 177.55-4.94 2.85v98.32l4.94-2.85v-98.32z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m360.01 177.55-4.94 2.85v98.32l4.94-2.85v-98.32z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="m350.12 177.55 4.95 2.85v98.32l-4.95-2.85v-98.32zM186.09 277.96l-4.94 2.86v98.31l4.94-2.85v-98.32z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m186.09 277.96-4.94 2.86v98.31l4.94-2.85v-98.32z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="m176.2 277.96 4.95 2.86v98.31l-4.95-2.85v-98.32zM117.01 238.01l-4.94 2.85v98.32l4.94-2.86v-98.31z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m117.01 238.01-4.94 2.85v98.32l4.94-2.86v-98.31z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="m107.13 238.01 4.94 2.85v98.32l-4.94-2.86v-98.31zM355.07 202.17l-168.98 97.56v-21.77l168.98-97.56v21.77z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m355.07 202.17-168.98 97.56v-21.77l168.98-97.56v21.77z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="M107 238.01v21.77l74.15 42.81v-21.77L107 238.01z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M132.74 187.12v59.75l-4.55-2.65v-57.1a2.28 2.28 0 0 1 4.55 0Z"
      style={{
        fill: '#37474f',
      }}
    />
    <path
      d="M179.72 118.61v7.41l8.44 3.42-8.44-10.83z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="m107.09 165.93 74.06 114.89 178.86-103.27-74.06-114.89-178.86 103.27z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m107.09 165.93 74.06 114.89 178.86-103.27-74.06-114.89-178.86 103.27z"
      style={{
        fill: '#fff',
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="m107.09 169.95 69.84 108.43 4.22 2.44-74.06-114.89v4.02z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m107.09 169.95 69.84 108.43 4.22 2.44-74.06-114.89v4.02z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="m134.87 167.02 60.84 94.39 146.94-84.84-60.84-94.39-146.94 84.84z"
      style={{
        fill: '#455a64',
      }}
    />
    <path
      d="M128.79 162.64h17.01v6.57h-17.01z"
      style={{
        fill: '#fff',
      }}
      transform="rotate(-75.64 137.294 165.928)"
    />
    <path
      d="M273.41 80.08h17.01v6.57h-17.01z"
      style={{
        fill: '#fff',
      }}
      transform="rotate(12.25 282.024 83.414)"
    />
    <path
      d="M200.74 243.46 154 171l122.82-70.91 46.77 72.42Zm-45.36-72.08 45.68 70.73 121.08-69.9-45.68-70.73Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="m206.57 239.67-46.23-71.57.22-.13 46.22 71.57-.21.13zM213.47 235.67l-46.23-71.57.21-.14 46.23 71.57-.21.14zM220.37 231.67l-46.23-71.57.21-.14 46.23 71.57-.21.14zM227.27 227.66l-46.23-71.57.21-.13 46.23 71.57-.21.13zM234.17 223.66l-46.23-71.57.21-.13 46.23 71.57-.21.13zM241.07 219.66l-46.23-71.57.21-.14 46.23 71.57-.21.14zM247.97 215.66l-46.23-71.58.21-.13 46.23 71.57-.21.14zM254.87 211.65l-46.23-71.57.21-.14 46.23 71.58-.21.13zM261.77 207.65l-46.23-71.57.21-.14 46.23 71.57-.21.14zM268.67 203.65l-46.23-71.58.21-.13 46.23 71.57-.21.14zM275.57 199.64l-46.23-71.57.21-.13 46.23 71.57-.21.13zM282.47 195.64l-46.23-71.57.21-.14 46.23 71.57-.21.14zM289.37 191.63l-46.23-71.57.21-.13 46.23 71.57-.21.13zM296.27 187.63l-46.23-71.57.21-.13 46.23 71.57-.21.13zM303.17 183.63l-46.23-71.57.21-.14 46.23 71.57-.21.14zM310.06 179.63l-46.22-71.57.21-.14 46.22 71.57-.21.14zM316.96 175.62l-46.22-71.57.21-.13 46.23 71.57-.22.13z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M148.74 141.23h140.82v.25H148.74z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 219.12 141.346)"
    />
    <path
      d="M152.33 146.8h140.81v.25H152.33z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 222.714 146.913)"
    />
    <path
      d="M155.92 152.38h140.81v.25H155.92z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 226.303 152.498)"
    />
    <path
      d="M159.52 157.96h140.81v.25H159.52z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 229.893 158.083)"
    />
    <path
      d="M163.11 163.54h140.81v.25H163.11z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 233.488 163.65)"
    />
    <path
      d="M166.7 169.12h140.81v.25H166.7z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 237.077 169.234)"
    />
    <path
      d="M170.29 174.7H311.1v.25H170.29z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 240.672 174.8)"
    />
    <path
      d="M173.88 180.27h140.81v.25H173.88z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 244.262 180.386)"
    />
    <path
      d="M177.47 185.85h140.81v.25H177.47z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 247.851 185.97)"
    />
    <path
      d="M181.07 191.43h140.81v.25H181.07z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 251.446 191.537)"
    />
    <path
      d="M184.66 197.01h140.81v.25H184.66z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 255.036 197.122)"
    />
    <path
      d="M188.25 202.59h140.81v.25H188.25z"
      style={{
        fill: '#263238',
      }}
      transform="rotate(-29.97 258.625 202.707)"
    />
    <path
      d="M206.68 225.45a.38.38 0 0 1-.32-.18l-21.44-33.12-6.49 3.75a.37.37 0 0 1-.52-.49l16.7-32.8a.39.39 0 0 1 .35-.21l38.35 1a.38.38 0 0 1 .35.29.37.37 0 0 1-.18.42l-6.48 3.53L248.39 201a.37.37 0 0 1 .05.29.38.38 0 0 1-.18.23l-41.39 23.88a.45.45 0 0 1-.19.05ZM185 191.27a.36.36 0 0 1 .32.18l21.44 33.12L247.55 201l-21.36-33.33a.37.37 0 0 1-.05-.29.36.36 0 0 1 .19-.24l5.57-3.05-36.73-1-16 31.46 5.71-3.3a.41.41 0 0 1 .12.02Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M248.07 201.54a.37.37 0 0 1-.18-.69l54.86-31.68-6.63-11-49.2-17.1-38.19 22a.37.37 0 0 1-.51-.13.39.39 0 0 1 .14-.52l38.34-22.13a.34.34 0 0 1 .31 0l49.48 17.2a.32.32 0 0 1 .2.16l6.9 11.46a.37.37 0 0 1 0 .29.39.39 0 0 1-.17.23l-55.2 31.86a.32.32 0 0 1-.15.05Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M296.37 158.22a.41.41 0 0 1-.32-.18l-21-33.17-13.53 7.82L271.75 149a.37.37 0 0 1-.11.52.38.38 0 0 1-.52-.11l-10.49-16.62a.38.38 0 0 1 0-.29.38.38 0 0 1 .17-.24L275 124a.37.37 0 0 1 .5.13l21.24 33.47a.38.38 0 0 1-.12.52.36.36 0 0 1-.25.1Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M234.28 178.9a.38.38 0 0 1-.33-.18.39.39 0 0 1 .14-.52l45.7-26.38a.37.37 0 0 1 .51.14.38.38 0 0 1-.13.51l-45.71 26.38a.31.31 0 0 1-.18.05ZM235.88 182.51a.39.39 0 0 1-.33-.19.37.37 0 0 1 .14-.51l45.16-26.26a.38.38 0 0 1 .31 0l12 4a.37.37 0 0 1 .2.15l7.14 11.26a.36.36 0 0 1-.12.51.37.37 0 0 1-.51-.11l-7.07-11.14-11.75-3.85-45 26.18a.41.41 0 0 1-.17-.04Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M237.84 184.76a.36.36 0 0 1-.32-.18.38.38 0 0 1 .13-.52l46.86-27.31a.37.37 0 1 1 .38.64L238 184.71a.32.32 0 0 1-.16.05ZM240.92 190.37a.38.38 0 0 1-.33-.18.39.39 0 0 1 .14-.52l52.15-30.18a.38.38 0 0 1 .52.13.39.39 0 0 1-.14.52l-52.16 30.18a.31.31 0 0 1-.18.05ZM239.54 187.59a.37.37 0 0 1-.32-.18.39.39 0 0 1 .13-.52l49-28.9a.38.38 0 1 1 .38.65l-49 28.9a.32.32 0 0 1-.19.05ZM202.64 189.63a.37.37 0 0 1-.32-.17l-2.71-4.2a8.34 8.34 0 0 1 14-9l3.09 4.78a.41.41 0 0 1 .05.29.38.38 0 0 1-.18.23l-13.76 8.07a.45.45 0 0 1-.17 0Zm4-16.49a7.61 7.61 0 0 0-3.8 1 7.59 7.59 0 0 0-2.58 10.69l2.52 3.9 13.11-7.68-2.89-4.44a7.59 7.59 0 0 0-6.38-3.47Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M209.52 185.6a.4.4 0 0 1-.32-.17l-7.2-11.18a.38.38 0 1 1 .63-.41l7.2 11.16a.37.37 0 0 1-.11.52.36.36 0 0 1-.2.08Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M199.15 183.88a.39.39 0 0 1-.33-.19.37.37 0 0 1 .14-.51l13.6-7.86a.37.37 0 0 1 .51.14.36.36 0 0 1-.13.51l-13.61 7.86a.37.37 0 0 1-.18.05ZM244.07 165.71a.37.37 0 0 1-.31-.17l-2.71-4.2a8.35 8.35 0 0 1 2.83-11.75 8.34 8.34 0 0 1 11.18 2.7l3.09 4.78a.37.37 0 0 1 .05.29.38.38 0 0 1-.17.24l-13.77 8.06a.41.41 0 0 1-.19.05Zm4-16.49a7.59 7.59 0 0 0-6.37 11.72l2.51 3.89 13.12-7.68-2.88-4.45a7.59 7.59 0 0 0-6.4-3.48Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M251 161.68a.37.37 0 0 1-.31-.17l-7.22-11.18a.38.38 0 0 1 .63-.41l7.22 11.18a.38.38 0 0 1-.11.52.42.42 0 0 1-.21.06Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M240.58 160a.37.37 0 0 1-.32-.19.36.36 0 0 1 .13-.51l13.61-7.89a.36.36 0 0 1 .51.13.39.39 0 0 1-.14.52l-13.6 7.85a.41.41 0 0 1-.19.09ZM271 142.23a.37.37 0 0 1-.31-.17l-1.53-2.36a4.86 4.86 0 0 1-.64-3.77 4.86 4.86 0 0 1 8.8-1.5l1.74 2.69a.42.42 0 0 1 .05.29.43.43 0 0 1-.18.24l-7.74 4.53a.41.41 0 0 1-.19.05Zm2.24-9.27a4.11 4.11 0 0 0-4 3.14 4.07 4.07 0 0 0 .55 3.19l1.32 2.06 7.1-4.15-1.53-2.36a4.1 4.1 0 0 0-3.43-1.84Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M274.88 140a.37.37 0 0 1-.31-.17l-4.06-6.28a.38.38 0 1 1 .63-.41l4.06 6.29a.37.37 0 0 1-.11.51.42.42 0 0 1-.21.06Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M269.05 139a.37.37 0 0 1-.32-.19.36.36 0 0 1 .13-.51l7.65-4.42a.39.39 0 0 1 .52.14.37.37 0 0 1-.14.51l-7.65 4.47a.41.41 0 0 1-.19 0ZM220.48 217.29a.37.37 0 0 1-.32-.17L210.39 202a8.35 8.35 0 0 1 14-9.06l10.18 15.76a.38.38 0 0 1-.11.52.37.37 0 0 1-.52-.11l-10.18-15.76a7.59 7.59 0 1 0-12.76 8.24l9.76 15.12a.38.38 0 0 1-.11.52.36.36 0 0 1-.17.06ZM211.65 222.57a.37.37 0 0 1-.31-.17L197.66 201a1.47 1.47 0 0 1-.18-1.14 1.42 1.42 0 0 1 .7-.92 1.47 1.47 0 0 1 1.95.48l13.76 21.3a.38.38 0 0 1-.11.52.37.37 0 0 1-.52-.11l-13.76-21.32a.72.72 0 0 0-.95-.23.7.7 0 0 0-.34.45.67.67 0 0 0 .09.55L212 222a.37.37 0 0 1-.11.51.42.42 0 0 1-.24.06ZM215.62 220.3a.36.36 0 0 1-.32-.18l-13.67-21.41a1.43 1.43 0 0 1-.19-1.14 1.46 1.46 0 0 1 2.65-.44l13.77 21.31a.38.38 0 0 1-.12.52.37.37 0 0 1-.51-.11l-13.77-21.31a.72.72 0 0 0-1-.24.74.74 0 0 0-.34.45.69.69 0 0 0 .09.56l13.67 21.41a.38.38 0 0 1-.11.52.36.36 0 0 1-.15.06ZM237.36 207.52a.36.36 0 0 1-.32-.18l-13.67-21.41a1.44 1.44 0 0 1-.19-1.14 1.46 1.46 0 0 1 2.65-.44l13.76 21.31a.37.37 0 0 1-.11.52.38.38 0 0 1-.52-.11l-13.76-21.31a.72.72 0 0 0-.95-.24.74.74 0 0 0-.34.45.7.7 0 0 0 .09.56l13.67 21.41a.37.37 0 0 1-.31.58ZM241.32 205.24a.4.4 0 0 1-.32-.17l-13.67-21.41a1.48 1.48 0 0 1-.19-1.14 1.43 1.43 0 0 1 .7-.92 1.45 1.45 0 0 1 1.95.48l13.77 21.3a.38.38 0 0 1-.11.52.37.37 0 0 1-.52-.11l-13.77-21.31a.71.71 0 0 0-.95-.23.74.74 0 0 0-.34.45.71.71 0 0 0 .09.55l13.68 21.42a.36.36 0 0 1-.12.51.36.36 0 0 1-.2.06Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M224.62 200.71a1.49 1.49 0 1 1 1.49-1.48 1.48 1.48 0 0 1-1.49 1.48Zm0-2.22a.74.74 0 1 0 .74.74.74.74 0 0 0-.74-.74ZM258.32 134.41a.38.38 0 0 1-.31-.16l-2.08-3.08a.36.36 0 0 1-.05-.3.36.36 0 0 1 .18-.24l19.43-11a.36.36 0 0 1 .49.12l2 2.88a.39.39 0 0 1 .06.3.39.39 0 0 1-.18.24l-19.32 11.15a.32.32 0 0 1-.22.09Zm-1.54-3.33 1.66 2.46 18.67-10.78-1.55-2.27Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M214.71 238c-4.93-10.35-14.3-15.58-21.1-11.68-6.84 3.9-8.69 15.45-4.19 25.94l-7.55 4.2 4.33 9.85 40.45-22.65-4.58-9.87Zm-18.78 10.34c-2.29-5.1-1.42-10.76 1.92-12.66 3.34-1.9 7.92.7 10.25 5.79l.1.23-12.2 6.9Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M214.71 238c-4.93-10.35-14.3-15.58-21.1-11.68-6.84 3.9-8.69 15.45-4.19 25.94l-7.55 4.2 4.33 9.85 40.45-22.65-4.58-9.87Zm-18.78 10.34c-2.29-5.1-1.42-10.76 1.92-12.66 3.34-1.9 7.92.7 10.25 5.79l.1.23-12.2 6.9Z"
      style={{
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="M189.35 264.89a.5.5 0 0 1-.46-.3l-1.07-2.46a.49.49 0 0 1 .25-.65.5.5 0 0 1 .66.25l1.08 2.46a.5.5 0 0 1-.26.65.46.46 0 0 1-.2.05ZM192.42 263.13a.51.51 0 0 1-.46-.29l-1.07-2.46a.51.51 0 0 1 .25-.66.51.51 0 0 1 .66.26l1.08 2.45a.5.5 0 0 1-.26.66.45.45 0 0 1-.2.04ZM195.49 261.38a.5.5 0 0 1-.46-.3l-1.03-2.45a.5.5 0 1 1 .92-.4l1.08 2.45a.51.51 0 0 1-.26.66.48.48 0 0 1-.25.04ZM198.56 259.63a.5.5 0 0 1-.46-.3l-1.1-2.45a.51.51 0 0 1 .26-.66.5.5 0 0 1 .66.26l1.08 2.45a.5.5 0 0 1-.46.7ZM201.63 257.88a.49.49 0 0 1-.46-.3l-1.08-2.45a.51.51 0 0 1 .26-.66.5.5 0 0 1 .66.26l1.07 2.45a.49.49 0 0 1-.25.66.51.51 0 0 1-.2.04ZM204.7 256.13a.49.49 0 0 1-.46-.3l-1.08-2.45a.5.5 0 0 1 .92-.41l1.07 2.46a.49.49 0 0 1-.25.65.53.53 0 0 1-.2.05ZM207.77 254.38a.51.51 0 0 1-.46-.3l-1.08-2.46a.51.51 0 0 1 .26-.66.52.52 0 0 1 .66.26l1.07 2.45a.5.5 0 0 1-.25.66.53.53 0 0 1-.2.05ZM210.83 252.62a.49.49 0 0 1-.45-.3l-1.08-2.45a.5.5 0 0 1 .26-.66.52.52 0 0 1 .66.26l1.07 2.45a.5.5 0 0 1-.25.66.52.52 0 0 1-.21.04ZM213.9 250.87a.49.49 0 0 1-.45-.3l-1.08-2.45a.5.5 0 0 1 .26-.66.51.51 0 0 1 .66.26l1.07 2.45a.5.5 0 0 1-.25.66.52.52 0 0 1-.21.04ZM217 249.12a.49.49 0 0 1-.45-.3l-1.08-2.45a.5.5 0 1 1 .92-.4l1.07 2.45a.5.5 0 0 1-.26.66.45.45 0 0 1-.2.04ZM220 247.37a.51.51 0 0 1-.46-.3l-1.07-2.45a.5.5 0 0 1 .91-.41l1.08 2.46a.5.5 0 0 1-.26.66.65.65 0 0 1-.2.04ZM223.11 245.62a.53.53 0 0 1-.46-.3l-1.07-2.46a.49.49 0 0 1 .25-.65.5.5 0 0 1 .66.25l1.08 2.45a.49.49 0 0 1-.26.66.46.46 0 0 1-.2.05Z"
      style={{
        fill: '#fafafa',
      }}
    />
    <path
      d="M193.07 126a2.61 2.61 0 0 1-2.61-2.62V67.85A18.33 18.33 0 0 1 199.58 52L222 39.09a15.78 15.78 0 0 1 16.09.17l12.1 7.19a2.61 2.61 0 0 1-2.67 4.49l-12.12-7.2a10.55 10.55 0 0 0-10.78-.13l-22.39 13a13.09 13.09 0 0 0-6.51 11.29v55.5a2.61 2.61 0 0 1-2.65 2.6Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M226.52 61.58a3.2 3.2 0 0 1 0-5.54l35.08-20.39a9.14 9.14 0 0 1 9.5.18Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="m226.51 74.45-11.2 12.3 66.35-39.73 11.74-11.2-66.89 38.63z"
      style={{
        fill: '#ebebeb',
      }}
    />
    <path
      d="M212.66 88.92 226.26 74l70.5-40.72-14.84 14.17Zm14.17-14.07L218 84.58l63.39-38 8.61-8.24Z"
      style={{
        fill: '#fafafa',
      }}
    />
    <path
      d="m289.88 38.45-8.54 8.15-63.26 37.88 8.76-9.62 63-36.41m3.52-2.63-66.85 38.63-11.2 12.3L281.66 47l11.74-11.2Z"
      style={{
        fill: '#37474f',
      }}
    />
    <path
      d="m226.51 74.45-11.15-6.44 66.89-38.62 11.15 6.43-66.89 38.63z"
      style={{
        fill: '#455a64',
      }}
    />
    <path
      d="m215.36 68.01-.05 18.74 11.2-12.3-11.15-6.44z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="m211.43 116-23.27 13.44-8.44-10.83 23.27-13.44 8.44 10.83z"
      style={{
        fill: '#37474f',
      }}
    />
    <path
      d="M199 119a1.71 1.71 0 1 1-1.71-1.72A1.7 1.7 0 0 1 199 119Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M184.36 270.75a1.57 1.57 0 0 1-.78-2.93L349 172.3a1.56 1.56 0 1 1 1.56 2.71l-165.41 95.53a1.61 1.61 0 0 1-.79.21ZM191 389.29s-13-12.74-5.62-34.09c4.16-12 18-20.75 25.81-21.58a36.8 36.8 0 0 0-6.14 10.38l-9.89 6.58 9.09-2.85-1.94 7.79s-8.46 5.11-9.71 6.23l9.12-2.39S201 381.37 191 389.29Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M191 389.29s-13-12.74-5.62-34.09c4.16-12 18-20.75 25.81-21.58a36.8 36.8 0 0 0-6.14 10.38l-9.89 6.58 9.09-2.85-1.94 7.79s-8.46 5.11-9.71 6.23l9.12-2.39S201 381.37 191 389.29Z"
      style={{
        opacity: 0.4,
      }}
    />
    <path
      d="M191 389.29s-6.76-26.67 3.24-42.22c0 0-11.72 13.73-3.24 42.22Z"
      style={{
        fill: '#fff',
      }}
    />
    <path
      d="m205.94 392.9-16-.2h-.17l-16 .2s-.18 19.68 5.88 27.68c1.67 2.13 5.59 3.62 10.17 3.62s8.5-1.5 10.17-3.63c6.12-8.01 5.95-27.67 5.95-27.67Z"
      style={{
        fill: '#37474f',
      }}
    />
    <ellipse
      cx={189.89}
      cy={392.9}
      rx={16.05}
      ry={8.62}
      style={{
        fill: '#455a64',
      }}
    />
    <path
      d="M189.89 390.62c5.52 0 10.19 1.77 11.84 4.22a3.46 3.46 0 0 0 .64-1.94c0-3.4-5.59-6.16-12.48-6.16s-12.49 2.76-12.49 6.16a3.46 3.46 0 0 0 .64 1.94c1.65-2.45 6.32-4.22 11.85-4.22Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M189.89 390.62c-5.53 0-10.2 1.77-11.85 4.22 1.65 2.46 6.32 4.23 11.85 4.23s10.19-1.77 11.84-4.23c-1.65-2.45-6.32-4.22-11.84-4.22Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="M190.08 395.91s-6.18-.24-11.49-8.46c-2.19-3.39-3.24-5.17-3.24-5.17l8.62-.64-9.66-2.41-4.56-7 8-.6s-6-2.09-10.24-2.11c0 0-7.39-13.07-9.56-14.93a41.91 41.91 0 0 1 29.21 14.51c12.18 14.4 4.73 27.18 2.92 26.81Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M190.08 395.91s3.87-23.3-20.82-37.32c0 0 25.63 12.31 20.82 37.32Z"
      style={{
        fill: '#fff',
      }}
    />
    <path
      d="M190.08 395.91s5.61.36 11.17-6.55c2.29-2.85 3.41-4.36 3.41-4.36l-7.72-1.39 8.94-1.27 4.78-5.86-7.18-1.29s5.58-1.33 9.43-.95c0 0 7.9-11.09 10-12.57A38 38 0 0 0 195.22 372c-12.32 11.84-6.8 24.07-5.14 23.91Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M190.08 395.91s5.61.36 11.17-6.55c2.29-2.85 3.41-4.36 3.41-4.36l-7.72-1.39 8.94-1.27 4.78-5.86-7.18-1.29s5.58-1.33 9.43-.95c0 0 7.9-11.09 10-12.57A38 38 0 0 0 195.22 372c-12.32 11.84-6.8 24.07-5.14 23.91Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M190.08 395.91s-1.29-21.39 22.3-31.71c0 0-24.28 8.69-22.3 31.71Z"
      style={{
        fill: '#fff',
      }}
    />
    <path
      d="M80.06 327.57v61c0 4.59 3 9.18 9.1 12.68 12.13 7 31.8 7 43.93 0 6.06-3.5 9.09-8.09 9.09-12.68v-61Z"
      style={{
        fill: '#37474f',
      }}
    />
    <ellipse
      cx={111.12}
      cy={327.31}
      rx={31.06}
      ry={17.93}
      style={{
        fill: '#455a64',
      }}
    />
    <path
      d="M132.41 335.75a21.66 21.66 0 0 1-3 2.1c-.21.13-.42.24-.64.36a29.4 29.4 0 0 1-4.38 1.91c-.6.21-1.23.41-1.86.57a38.54 38.54 0 0 1-4.37 1c-1.27.2-2.56.36-3.86.44-.52.05-1 .08-1.57.09h-2.95c-1.24 0-2.46-.12-3.67-.25a38.09 38.09 0 0 1-4.58-.8c-.6-.13-1.2-.28-1.78-.46a30.22 30.22 0 0 1-6.88-2.84 21.43 21.43 0 0 1-2.69-1.87c-5.88-4.68-6.46-10.89-1.74-15.88a19.36 19.36 0 0 1 4.41-3.4 28.66 28.66 0 0 1 5.72-2.49c.37-.12.77-.25 1.16-.35a30.21 30.21 0 0 1 3.22-.76c1.17-.23 2.36-.4 3.57-.53a44.42 44.42 0 0 1 11.62.32l.35.06a35 35 0 0 1 4 .91 30.8 30.8 0 0 1 5.36 2c.53.25 1 .53 1.52.81a24.53 24.53 0 0 1 2.26 1.48 16 16 0 0 1 2.89 2.76c3.84 4.8 3.13 10.45-2.11 14.82Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M112.08 248.38v19h9.71v-12.95s-3.62-5.27-9.71-6.05Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M112.08 248.38v19h9.71v-12.95s-3.62-5.27-9.71-6.05Z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="M118.14 253.11v88.56c-1.27.2-2.56.36-3.86.44-.52.05-1 .08-1.57.09h-2.95c-1.24 0-2.46-.12-3.67-.25a38.09 38.09 0 0 1-4.58-.8c-.6-.13-1.2-.28-1.78-.46v-87.58Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M118.14 253.11v88.56c-1.27.2-2.56.36-3.86.44-.52.05-1 .08-1.57.09h-2.95c-1.24 0-2.46-.12-3.67-.25a38.09 38.09 0 0 1-4.58-.8c-.6-.13-1.2-.28-1.78-.46v-87.58Z"
      style={{
        fill: '#fff',
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M122.51 256.09v84.6a38.54 38.54 0 0 1-4.37 1c-1.27.2-2.56.36-3.86.44-.52.05-1 .08-1.57.09v-78.87a16 16 0 0 0 5.43-1.86 9.63 9.63 0 0 0 3.65-3.59 5.93 5.93 0 0 0 .72-1.81Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M122.51 256.09v84.6a38.54 38.54 0 0 1-4.37 1c-1.27.2-2.56.36-3.86.44-.52.05-1 .08-1.57.09v-78.87a16 16 0 0 0 5.43-1.86 9.63 9.63 0 0 0 3.65-3.59 5.93 5.93 0 0 0 .72-1.81Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="M113.17 263.72a.46.46 0 0 1-.45-.37.45.45 0 0 1 .36-.54 16.11 16.11 0 0 0 4.9-1.76c2.32-1.35 3.61-3.11 3.61-5s-1.29-3.61-3.61-4.95a18.41 18.41 0 0 0-9-2.16.46.46 0 0 1-.46-.46.47.47 0 0 1 .46-.46 19.33 19.33 0 0 1 9.51 2.28c2.63 1.51 4.07 3.56 4.07 5.75s-1.44 4.24-4.07 5.76a16.79 16.79 0 0 1-5.18 1.86Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M113.17 263.72a.46.46 0 0 1-.45-.37.45.45 0 0 1 .36-.54 16.11 16.11 0 0 0 4.9-1.76c2.32-1.35 3.61-3.11 3.61-5s-1.29-3.61-3.61-4.95a18.41 18.41 0 0 0-9-2.16.46.46 0 0 1-.46-.46.47.47 0 0 1 .46-.46 19.33 19.33 0 0 1 9.51 2.28c2.63 1.51 4.07 3.56 4.07 5.75s-1.44 4.24-4.07 5.76a16.79 16.79 0 0 1-5.18 1.86Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <ellipse
      cx={108.93}
      cy={253.37}
      rx={9.2}
      ry={5.31}
      style={{
        fill: '#0c0c0c',
      }}
    />
    <ellipse
      cx={108.93}
      cy={253.37}
      rx={9.2}
      ry={5.31}
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="m132.46 280.93-2 14.05 7.19 1 1.39-9.57a11.53 11.53 0 0 0-6.58-5.48Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m132.46 280.93-2 14.05 7.19 1 1.39-9.57a11.53 11.53 0 0 0-6.58-5.48Z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="m136.44 285.08-.83 5.79-.07.42v.37l-.57 4-3.27 22.62-2.9 20a29.4 29.4 0 0 1-4.38 1.91c-.6.21-1.23.41-1.86.57a38.54 38.54 0 0 1-4.37 1c-1.27.2-2.56.36-3.86.44l3.86-26.67.35-2.43 4-27.81.31-2.09 9.11 1.32 4.47.65Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m136.44 285.08-.83 5.79-.07.42v.37l-.57 4-3.27 22.62-2.9 20a29.4 29.4 0 0 1-4.38 1.91c-.6.21-1.23.41-1.86.57a38.54 38.54 0 0 1-4.37 1c-1.27.2-2.56.36-3.86.44l3.86-26.67.35-2.43 4-27.81.31-2.09 9.11 1.32 4.47.65Z"
      style={{
        fill: '#fff',
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M139.36 287.76 134.54 321l-2.13 14.75a21.66 21.66 0 0 1-3 2.1c-.21.13-.42.24-.64.36a29.4 29.4 0 0 1-4.38 1.91l3.5-24.17 3-20.9.43-3a11.81 11.81 0 0 0 4.21-.79 7.16 7.16 0 0 0 3.07-2.25 4.56 4.56 0 0 0 .76-1.25Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M139.36 287.76 134.54 321l-2.13 14.75a21.66 21.66 0 0 1-3 2.1c-.21.13-.42.24-.64.36a29.4 29.4 0 0 1-4.38 1.91l3.5-24.17 3-20.9.43-3a11.81 11.81 0 0 0 4.21-.79 7.16 7.16 0 0 0 3.07-2.25 4.56 4.56 0 0 0 .76-1.25Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="M131.63 292.4a.34.34 0 0 1-.3-.32.35.35 0 0 1 .33-.37 12 12 0 0 0 3.81-.77c1.86-.75 3-1.91 3.2-3.28s-.56-2.81-2.14-4.05a13.8 13.8 0 0 0-6.46-2.57.34.34 0 1 1 .1-.68 14.43 14.43 0 0 1 6.79 2.7c1.78 1.41 2.63 3.07 2.39 4.7s-1.52 3-3.63 3.82a12.76 12.76 0 0 1-4 .83Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M131.63 292.4a.34.34 0 0 1-.3-.32.35.35 0 0 1 .33-.37 12 12 0 0 0 3.81-.77c1.86-.75 3-1.91 3.2-3.28s-.56-2.81-2.14-4.05a13.8 13.8 0 0 0-6.46-2.57.34.34 0 1 1 .1-.68 14.43 14.43 0 0 1 6.79 2.7c1.78 1.41 2.63 3.07 2.39 4.7s-1.52 3-3.63 3.82a12.76 12.76 0 0 1-4 .83Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="M134.82 282.21c2.43 1.92 2.07 4.41-.81 5.56a10.76 10.76 0 0 1-9.63-1.4c-2.44-1.92-2.08-4.41.81-5.56a10.76 10.76 0 0 1 9.63 1.4Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M134.82 282.21c2.43 1.92 2.07 4.41-.81 5.56a10.76 10.76 0 0 1-9.63-1.4c-2.44-1.92-2.08-4.41.81-5.56a10.76 10.76 0 0 1 9.63 1.4Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="M93.26 270.68 95 286.23l8-.87-1.16-10.59s-3.51-4-8.58-4.09Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M93.26 270.68 95 286.23l8-.87-1.16-10.59s-3.51-4-8.58-4.09Z"
      style={{
        fill: '#fff',
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="M106.09 342a38.09 38.09 0 0 1-4.58-.8c-.6-.13-1.2-.28-1.78-.46a30.22 30.22 0 0 1-6.88-2.84 21.43 21.43 0 0 1-2.67-1.9l-1.74-15.88-4.86-44.5 10.09-1.11 5-.54.7 6.42v.87l.27 2.44.21 1.95 3 27.47Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M106.09 342a38.09 38.09 0 0 1-4.58-.8c-.6-.13-1.2-.28-1.78-.46a30.22 30.22 0 0 1-6.88-2.84 21.43 21.43 0 0 1-2.67-1.9l-1.74-15.88-4.86-44.5 10.09-1.11 5-.54.7 6.42v.87l.27 2.44.21 1.95 3 27.47Z"
      style={{
        fill: '#fff',
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M106.09 342a38.09 38.09 0 0 1-4.58-.8l-1.78-16.28-1.16-10.6-3.08-28.09-.36-3.29a13 13 0 0 0 4.28-2c.12-.08.22-.16.32-.24a7.83 7.83 0 0 0 2.35-3 4.91 4.91 0 0 0 .43-1.56l4 36.57 3.24 29.57c-1.23-.11-2.45-.2-3.66-.28Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M106.09 342a38.09 38.09 0 0 1-4.58-.8l-1.78-16.28-1.16-10.6-3.08-28.09-.36-3.29a13 13 0 0 0 4.28-2c.12-.08.22-.16.32-.24a7.83 7.83 0 0 0 2.35-3 4.91 4.91 0 0 0 .43-1.56l4 36.57 3.24 29.57c-1.23-.11-2.45-.2-3.66-.28Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="M95.54 283.15a.39.39 0 0 1-.41-.26.38.38 0 0 1 .26-.48 13.41 13.41 0 0 0 3.85-1.88c1.78-1.31 2.68-2.87 2.51-4.39s-1.37-2.84-3.4-3.73a15.3 15.3 0 0 0-7.61-1 .37.37 0 0 1-.42-.33.38.38 0 0 1 .34-.42 15.81 15.81 0 0 1 8 1c2.28 1 3.65 2.55 3.85 4.35s-.8 3.61-2.82 5.08a13.74 13.74 0 0 1-4.08 2Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M95.54 283.15a.39.39 0 0 1-.41-.26.38.38 0 0 1 .26-.48 13.41 13.41 0 0 0 3.85-1.88c1.78-1.31 2.68-2.87 2.51-4.39s-1.37-2.84-3.4-3.73a15.3 15.3 0 0 0-7.61-1 .37.37 0 0 1-.42-.33.38.38 0 0 1 .34-.42 15.81 15.81 0 0 1 8 1c2.28 1 3.65 2.55 3.85 4.35s-.8 3.61-2.82 5.08a13.74 13.74 0 0 1-4.08 2Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="M96.13 271.39c3.14 1.37 3.44 4.13.68 6.16a11.87 11.87 0 0 1-10.67 1.16c-3.13-1.37-3.43-4.13-.67-6.16a11.85 11.85 0 0 1 10.66-1.16Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M96.13 271.39c3.14 1.37 3.44 4.13.68 6.16a11.87 11.87 0 0 1-10.67 1.16c-3.13-1.37-3.43-4.13-.67-6.16a11.85 11.85 0 0 1 10.66-1.16Z"
      style={{
        fill: '#fff',
        opacity: 0.5,
      }}
    />
    <path
      d="m317.75 139-75.54 43.61a.58.58 0 0 1-.77-.16l-8.55-11.92a.59.59 0 0 1 .18-.85l75.55-43.62a.58.58 0 0 1 .77.17l8.55 11.92a.59.59 0 0 1-.19.85Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <g
      style={{
        clipPath: 'url(#a)',
      }}
    >
      <path
        d="M236.59 172a.12.12 0 0 1-.1 0l-2.11-2.94a.12.12 0 0 1 0-.17.14.14 0 0 1 .18 0l2.11 2.95a.12.12 0 0 1 0 .17.12.12 0 0 1-.08-.01ZM236.59 170a.12.12 0 0 1-.1 0l-1.08-1.49a.14.14 0 0 1 0-.18.13.13 0 0 1 .18 0l1.07 1.49a.13.13 0 0 1 0 .18ZM237.66 169.35a.1.1 0 0 1-.1 0l-1.08-1.49a.13.13 0 1 1 .21-.15l1.07 1.5a.12.12 0 0 1 0 .17.08.08 0 0 1-.1-.03ZM238.73 168.73a.11.11 0 0 1-.1-.06l-1.07-1.49a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.12.12 0 0 1 0 .17.09.09 0 0 1-.08.06ZM239.8 168.1a.12.12 0 0 1-.1 0l-1.07-1.49a.14.14 0 0 1 0-.18.13.13 0 0 1 .18 0l1.07 1.49a.14.14 0 0 1 0 .18ZM241.91 169a.14.14 0 0 1-.1-.06L239.7 166a.12.12 0 0 1 .2-.14l2.12 2.94a.13.13 0 0 1 0 .17.13.13 0 0 1-.11.03ZM241.91 166.88a.1.1 0 0 1-.1 0l-1.07-1.49a.14.14 0 0 1 0-.18.14.14 0 0 1 .18 0l1.07 1.5a.12.12 0 0 1 0 .17.08.08 0 0 1-.08 0ZM243 166.26a.12.12 0 0 1-.1-.06l-1.07-1.49a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.12.12 0 0 1 0 .17.13.13 0 0 1-.08.06ZM244.05 165.63a.14.14 0 0 1-.1 0l-1.07-1.5a.12.12 0 0 1 .2-.14l1.07 1.49a.14.14 0 0 1 0 .18ZM245.12 165a.11.11 0 0 1-.1-.05l-1.02-1.49a.13.13 0 1 1 .2-.15l1.08 1.5a.13.13 0 0 1 0 .17.12.12 0 0 1-.16.02ZM247.24 165.85a.16.16 0 0 1-.11 0l-2.13-2.99a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l2.12 2.94a.12.12 0 0 1 0 .17.11.11 0 0 1-.05.06ZM247.23 163.79a.12.12 0 0 1-.1-.06l-1.07-1.49a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.07 1.5a.12.12 0 0 1 0 .17.13.13 0 0 1-.07.05ZM248.3 163.16a.14.14 0 0 1-.1 0l-1.07-1.5a.12.12 0 0 1 .2-.14l1.08 1.49a.14.14 0 0 1 0 .18ZM249.38 162.53a.16.16 0 0 1-.11-.05L248.2 161a.13.13 0 1 1 .2-.15l1.08 1.49a.14.14 0 0 1 0 .18ZM250.45 161.91a.14.14 0 0 1-.11-.06l-1.07-1.49a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.08 1.5a.12.12 0 0 1 0 .17.11.11 0 0 1-.07.05ZM252.56 162.75a.12.12 0 0 1-.1-.05l-2.12-2.94a.13.13 0 0 1 0-.18.13.13 0 0 1 .17 0l2.12 2.94a.13.13 0 0 1 0 .18ZM252.55 160.69a.16.16 0 0 1-.1-.05l-1.07-1.5a.12.12 0 0 1 .2-.14l1.08 1.49a.14.14 0 0 1 0 .18ZM253.63 160.06a.16.16 0 0 1-.11-.05l-1.07-1.49a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l1.08 1.49a.14.14 0 0 1 0 .18ZM254.7 159.44a.11.11 0 0 1-.1-.06l-1.08-1.49a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.08 1.5a.12.12 0 0 1 0 .17.11.11 0 0 1-.07.05ZM255.77 158.81a.12.12 0 0 1-.1-.05l-1.08-1.5a.13.13 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.13.13 0 0 1 0 .18ZM257.88 159.65a.1.1 0 0 1-.1-.05l-2.12-2.94a.13.13 0 0 1 0-.17.13.13 0 0 1 .18 0l2.11 2.94a.12.12 0 0 1 0 .17.08.08 0 0 1-.07.05ZM257.88 157.59a.12.12 0 0 1-.1-.05l-1.08-1.49a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l1.08 1.49a.13.13 0 0 1 0 .18ZM259 157a.1.1 0 0 1-.1-.05l-1.08-1.49a.13.13 0 0 1 .21-.15l1.07 1.5a.12.12 0 0 1 0 .17.1.1 0 0 1-.1.02ZM260 156.34a.12.12 0 0 1-.1-.05l-1.08-1.5a.13.13 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.12.12 0 0 1 0 .17.11.11 0 0 1-.07.06ZM261.09 155.71a.12.12 0 0 1-.1-.05l-1.08-1.49a.14.14 0 0 1 0-.18.13.13 0 0 1 .18 0l1.07 1.49a.13.13 0 0 1 0 .18ZM263.2 156.56a.11.11 0 0 1-.1-.06l-2.1-2.94a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l2.11 2.94a.12.12 0 0 1 0 .17.13.13 0 0 1-.09.06ZM263.2 154.49a.1.1 0 0 1-.1-.05L262 153a.13.13 0 0 1 .21-.15l1.07 1.5a.12.12 0 0 1 0 .17.1.1 0 0 1-.08-.03ZM264.27 153.87a.11.11 0 0 1-.1-.06l-1.08-1.49a.13.13 0 0 1 .21-.14l1.07 1.49a.12.12 0 0 1 0 .17.11.11 0 0 1-.1.03ZM265.34 153.24a.12.12 0 0 1-.1-.05l-1.07-1.5a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.13.13 0 0 1 0 .18ZM266.41 152.61a.1.1 0 0 1-.1-.05l-1.07-1.49a.14.14 0 0 1 0-.18.14.14 0 0 1 .18 0l1.07 1.5a.12.12 0 0 1 0 .17.12.12 0 0 1-.08.05ZM268.52 153.46a.14.14 0 0 1-.1-.05l-2.11-2.94a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l2.11 2.94a.13.13 0 0 1 0 .18ZM268.52 151.4a.11.11 0 0 1-.1-.06l-1.08-1.49a.13.13 0 0 1 .21-.14l1.07 1.49a.12.12 0 0 1 0 .17.09.09 0 0 1-.1.03ZM269.59 150.77a.12.12 0 0 1-.1-.05l-1.07-1.5a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.14.14 0 0 1 0 .18ZM270.66 150.14a.11.11 0 0 1-.1 0l-1.07-1.49a.13.13 0 1 1 .2-.15l1.07 1.5a.12.12 0 0 1 0 .17.12.12 0 0 1-.1-.03ZM271.73 149.52a.14.14 0 0 1-.1-.06l-1.07-1.46a.12.12 0 0 1 .2-.14l1.08 1.49a.13.13 0 0 1 0 .17.11.11 0 0 1-.11 0ZM273.85 150.36a.16.16 0 0 1-.11-.05l-2.11-2.94a.13.13 0 1 1 .2-.15l2.12 2.94a.14.14 0 0 1 0 .18ZM273.84 148.3a.14.14 0 0 1-.1-.05l-1.07-1.5a.12.12 0 0 1 .2-.14l1.07 1.49a.14.14 0 0 1 0 .18ZM274.91 147.67a.16.16 0 0 1-.1 0l-1.07-1.49a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l1.08 1.5a.13.13 0 0 1 0 .17.12.12 0 0 1-.08 0ZM276 147.05a.14.14 0 0 1-.11-.06l-1.07-1.49a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.08 1.5a.13.13 0 0 1 0 .17.11.11 0 0 1-.07.05ZM277.06 146.42a.16.16 0 0 1-.11 0l-1.07-1.5a.12.12 0 1 1 .2-.14l1.08 1.49a.14.14 0 0 1 0 .18ZM279.17 147.26a.1.1 0 0 1-.1 0l-2.07-2.99a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l2.12 2.94a.12.12 0 0 1 0 .17.1.1 0 0 1-.12.05ZM279.17 145.2a.16.16 0 0 1-.11 0l-1.06-1.54a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l1.08 1.49a.14.14 0 0 1 0 .18ZM280.24 144.58a.14.14 0 0 1-.11-.06l-1.07-1.52a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.08 1.5a.13.13 0 0 1 0 .17.11.11 0 0 1-.07.08ZM281.31 144a.12.12 0 0 1-.1 0l-1.08-1.5a.12.12 0 1 1 .2-.14l1.08 1.49a.13.13 0 0 1 0 .18ZM282.38 143.32a.12.12 0 0 1-.1 0l-1.08-1.49a.13.13 0 0 1 .21-.15l1.07 1.49a.13.13 0 0 1 0 .18ZM284.49 144.17a.11.11 0 0 1-.1-.06l-2.12-2.94a.13.13 0 0 1 .21-.14l2.11 2.94a.12.12 0 0 1 0 .17.11.11 0 0 1-.1.03ZM284.49 142.1a.13.13 0 0 1-.11 0l-1.07-1.49a.13.13 0 0 1 0-.18.13.13 0 0 1 .17 0l1.08 1.5a.12.12 0 0 1 0 .17.1.1 0 0 1-.07 0ZM285.56 141.48a.12.12 0 0 1-.1 0l-1.08-1.5a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.08 1.49a.12.12 0 0 1 0 .17.11.11 0 0 1-.07.01ZM286.63 140.85a.12.12 0 0 1-.1 0l-1.08-1.49a.14.14 0 0 1 0-.18.13.13 0 0 1 .18 0l1.07 1.49a.13.13 0 0 1 0 .18ZM287.7 140.22a.1.1 0 0 1-.1-.05l-1.08-1.49a.14.14 0 0 1 0-.18.14.14 0 0 1 .18 0l1.07 1.5a.12.12 0 0 1 0 .17.08.08 0 0 1-.07.05ZM289.81 141.07a.12.12 0 0 1-.1 0l-2.12-2.94a.14.14 0 0 1 0-.18.13.13 0 0 1 .18 0l2.11 2.94a.13.13 0 0 1 0 .18ZM289.81 139a.12.12 0 0 1-.1 0l-1.08-1.5a.13.13 0 0 1 .21-.14l1.07 1.49a.12.12 0 0 1 0 .17.11.11 0 0 1-.1-.02ZM290.88 138.38a.12.12 0 0 1-.1 0l-1.08-1.5a.13.13 0 0 1 .21-.14l1.07 1.49a.13.13 0 0 1 0 .18ZM292 137.75a.1.1 0 0 1-.1-.05l-1.07-1.49a.14.14 0 0 1 0-.18.14.14 0 0 1 .18 0l1.07 1.5a.12.12 0 0 1 0 .17.08.08 0 0 1-.08.05ZM293 137.13a.12.12 0 0 1-.1 0l-1.07-1.5a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.12.12 0 0 1 0 .17.09.09 0 0 1-.08.01ZM295.13 138a.14.14 0 0 1-.1-.05l-2.11-2.95a.13.13 0 0 1 .2-.15l2.12 2.94a.14.14 0 0 1 0 .18ZM295.13 135.91a.12.12 0 0 1-.1 0l-1.07-1.5a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.13.13 0 0 1 0 .18ZM296.2 135.28a.1.1 0 0 1-.1-.05l-1.1-1.49a.14.14 0 0 1 0-.18.14.14 0 0 1 .18 0l1.07 1.5a.12.12 0 0 1 0 .17.12.12 0 0 1-.05.05ZM297.27 134.66a.12.12 0 0 1-.1-.06l-1.07-1.49a.12.12 0 0 1 0-.17.13.13 0 0 1 .18 0l1.07 1.49a.12.12 0 0 1 0 .17.13.13 0 0 1-.08.06ZM298.34 134a.14.14 0 0 1-.1-.05l-1.07-1.5a.12.12 0 0 1 .2-.14l1.08 1.49a.14.14 0 0 1 0 .18ZM300.46 134.88a.14.14 0 0 1-.11-.06l-2.11-2.94a.12.12 0 0 1 .2-.14l2.12 2.94a.13.13 0 0 1 0 .17.11.11 0 0 1-.1.03ZM300.45 132.81a.14.14 0 0 1-.1-.05l-1.07-1.49a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l1.07 1.5a.12.12 0 0 1 0 .17.12.12 0 0 1-.07.05ZM301.52 132.19a.12.12 0 0 1-.1-.06l-1.07-1.49a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.07 1.49a.12.12 0 0 1 0 .17.13.13 0 0 1-.07.06ZM302.59 131.56a.16.16 0 0 1-.1-.05l-1.07-1.5a.12.12 0 0 1 .2-.14l1.08 1.49a.14.14 0 0 1 0 .18ZM303.67 130.93a.16.16 0 0 1-.11-.05l-1.07-1.49a.13.13 0 0 1 0-.18.13.13 0 0 1 .17 0l1.08 1.49a.14.14 0 0 1 0 .18ZM305.78 131.78a.12.12 0 0 1-.1-.05l-2.12-2.95a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l2.12 2.94a.12.12 0 0 1 0 .17.11.11 0 0 1-.07.06ZM305.77 129.72a.14.14 0 0 1-.1-.06l-1.07-1.49a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.08 1.5a.13.13 0 0 1 0 .17.11.11 0 0 1-.08.05ZM306.85 129.09a.16.16 0 0 1-.11-.05l-1.07-1.5a.12.12 0 0 1 .2-.14l1.08 1.49a.14.14 0 0 1 0 .18ZM307.92 128.46a.12.12 0 0 1-.1-.05l-1.08-1.49a.13.13 0 0 1 0-.18.12.12 0 0 1 .17 0l1.08 1.49a.13.13 0 0 1 0 .18ZM309 127.84a.11.11 0 0 1-.1-.06l-1.08-1.49a.12.12 0 0 1 0-.17.12.12 0 0 1 .17 0l1.08 1.5a.12.12 0 0 1 0 .17.11.11 0 0 1-.07.05Z"
        style={{
          fill: '#263238',
        }}
      />
    </g>
    <path
      d="m246.8 187.33-8.36 3.3a.19.19 0 0 0 0 .37l8.93 1.39Z"
      style={{
        fill: '#e0e0e0',
      }}
    />
    <path
      d="m285.68 187.78-38.27 4.61a4.62 4.62 0 0 1-.69-4.88l.08-.18 38.27-4.6Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m289.38 187.39-.27-5.1-4 .44a1.26 1.26 0 0 0-1.13.79 4 4 0 0 0 .14 3.61 1.26 1.26 0 0 0 1.11.7Z"
      style={{
        fill: '#f28f8f',
      }}
    />
    <path
      d="M290.27 183a4 4 0 0 1 .14 3.62 1.1 1.1 0 0 1-2.09.08 4 4 0 0 1-.14-3.61 1.11 1.11 0 0 1 2.09-.09Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M241.8 190.17a5.28 5.28 0 0 1 .09-.9l-3.45 1.36a.19.19 0 0 0 0 .37l3.55.55a4.86 4.86 0 0 1-.19-1.38Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="m309.22 318.57-.55 8.22 14.1.15.96-6.58-14.51-1.79z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M309.05 322.13a8.88 8.88 0 0 0 7.15 3.74c4.76 0 7-2 7-2s1.09 1.9 1.09 6.18v7.4s-2.55 2.3-9.16 2.3a37.83 37.83 0 0 1-7.93-.81 26 26 0 0 0-6.77-.48c-6.9.37-20.83 0-20.83-9.38 0-6.13 6.22-6.57 14.18-5.31a70.94 70.94 0 0 0 15.27-1.64Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M307.22 338.92a26 26 0 0 0-6.77-.48c-6.65.36-19.8 0-20.77-8.38a9.09 9.09 0 0 0-.06.93c0 9.87 15.56 9.77 21.94 9.31a17.23 17.23 0 0 1 5.11.43 38 38 0 0 0 8.48.93 18.92 18.92 0 0 0 7.24-1.23 3.11 3.11 0 0 0 1.92-2.89v-.11s-2.55 2.3-9.16 2.3a37.83 37.83 0 0 1-7.93-.81Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M279.62 329.06c0 5.05 4.08 7.49 8.91 8.61 0-13.16 5.27-13.92 5.27-13.92-7.96-1.26-14.18-.82-14.18 5.31Z"
      style={{
        fill: '#fafafa',
      }}
    />
    <path
      d="m303.65 323.18 2.94-2.73a2.22 2.22 0 0 1 3.64 1 6.24 6.24 0 0 1 .16 2.21Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M293.29 330a.46.46 0 0 1-.44-.5c.35-5.52 3.24-6.4 3.36-6.43a.47.47 0 0 1 .59.32.48.48 0 0 1-.32.58c-.11 0-2.38.79-2.69 5.59a.47.47 0 0 1-.5.44ZM297.3 329.9a.47.47 0 0 1-.45-.49c.21-5.53 3.08-6.47 3.2-6.5a.46.46 0 0 1 .59.31.47.47 0 0 1-.31.59c-.11 0-2.36.84-2.54 5.64a.47.47 0 0 1-.49.45ZM301.57 330a.47.47 0 0 1-.47-.43c-.49-5.53 2.25-6.75 2.37-6.8a.47.47 0 0 1 .37.87c-.1.05-2.22 1.07-1.8 5.85a.46.46 0 0 1-.42.51Z"
      style={{
        fill: '#fafafa',
      }}
    />
    <path
      d="M306.16 162.93s-9.26-6-11.21-9.85c-1.46-2.85-5-3.41-4.81-5.27s6.37-1 8.37 1.87c0 0-1-4.19-3.28-6.36-.8-.76-1.6-1.48-2.41-2.23-2.64-2.46 5.41-4 6.44-4.13 3.74-.48 6.69.1 9.69 2.66 5.68 4.86 9.61 18.46 9.61 18.46Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="m341.2 181.84-22.77-24.09s-9.86-1.82-12.27 5.18c0 0 17.11 25.69 23.06 32.7a4.11 4.11 0 0 0 2.88 1.63l55.81 10.55v-19.76Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M334.24 245.21s-21.15-7.72-25 7.48 0 65.88 0 65.88 5.32 5.39 14.51 1.79c0 0 3.48-19.48 6.73-26.48s.3-18.3-.51-23.49Z"
      style={{
        fill: '#37474f',
      }}
    />
    <path
      d="m277.94 336.95-.55 8.22 14.1.15.96-6.58-14.51-1.79z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M277.77 340.51a8.88 8.88 0 0 0 7.15 3.74c4.76 0 7-2 7-2s1.09 1.9 1.09 6.17v7.41s-2.55 2.3-9.16 2.3a38.71 38.71 0 0 1-7.94-.81 26 26 0 0 0-6.76-.48c-6.9.37-20.83 0-20.83-9.38 0-6.14 6.22-6.58 14.17-5.31a71.74 71.74 0 0 0 15.28-1.64Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M275.93 357.3a26 26 0 0 0-6.76-.48c-6.65.36-19.8 0-20.77-8.38a8.9 8.9 0 0 0-.06.93c0 9.87 15.56 9.77 21.94 9.31a17.23 17.23 0 0 1 5.11.43 38 38 0 0 0 8.48.93 18.92 18.92 0 0 0 7.24-1.23 3.12 3.12 0 0 0 1.92-2.89v-.11s-2.55 2.3-9.16 2.3a38.71 38.71 0 0 1-7.94-.81Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M248.34 347.44c0 5.05 4.08 7.49 8.91 8.6 0-13.15 5.26-13.91 5.26-13.91-7.95-1.27-14.17-.83-14.17 5.31Z"
      style={{
        fill: '#fafafa',
      }}
    />
    <path
      d="m272.37 341.55 2.94-2.72a2.22 2.22 0 0 1 3.64 1 6.22 6.22 0 0 1 .16 2.21Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M262 348.39a.46.46 0 0 1-.44-.5c.35-5.53 3.24-6.4 3.36-6.44a.48.48 0 0 1 .59.33.47.47 0 0 1-.33.58c-.11 0-2.37.8-2.68 5.59a.46.46 0 0 1-.5.44ZM266 348.28a.47.47 0 0 1-.45-.49c.21-5.54 3.08-6.47 3.2-6.51a.47.47 0 0 1 .59.32.45.45 0 0 1-.31.58c-.11 0-2.36.85-2.54 5.65a.47.47 0 0 1-.49.45ZM270.29 348.35a.48.48 0 0 1-.47-.43c-.49-5.53 2.25-6.75 2.37-6.8a.47.47 0 0 1 .37.87c-.1 0-2.22 1.07-1.8 5.84a.48.48 0 0 1-.43.52Z"
      style={{
        fill: '#fafafa',
      }}
    />
    <path
      d="M308.3 256.36s-21.45-6-25.32 9.19-5 71.4-5 71.4 5.32 5.39 14.51 1.79c0 0 3.48-19.48 6.73-26.48s5.35-23.81 4.53-29Z"
      style={{
        fill: '#37474f',
      }}
    />
    <path
      d="m337.94 317.33 14 86.27a2.3 2.3 0 0 0 2.27 1.93 2.3 2.3 0 0 0 2.29-2.56l-10.39-88.61ZM316.68 299.62l-15.45 73.27a2.31 2.31 0 0 1-2.36 1.83 2.31 2.31 0 0 1-2.17-2.67l11.95-75.76Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="m363.9 272.94-15.45 73.26a2.3 2.3 0 0 1-2.36 1.83 2.31 2.31 0 0 1-2.17-2.66l11.95-75.77ZM387.53 303.09 399.64 377a2.3 2.3 0 0 0 2.27 1.93 2.31 2.31 0 0 0 2.3-2.56l-8.5-76.23Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="m300 288.06 1 2.82c1.58 3.24 4.45 6.2 8.49 8.95 15.36 10.44 29.92 21.55 36.62 14.53s17.72-38.65 20.34-47.84c.47-1.67 1-3.27 1.58-4.82l-14.1-4.7a23.74 23.74 0 0 0-20.48 2.64l-27.94 18.21a12.16 12.16 0 0 0-5.53 10.2Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="m334.24 245.21 65.35 21.66s2.57 23-26.51 35l-47.55-32.27s-.74-23.09 8.71-24.39Z"
      style={{
        fill: '#37474f',
      }}
    />
    <path
      d="m308.3 256.36 38.26 10.8 3.14-3.32-40.88-9.32-.52 1.84z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M387.53 274.11s2.54 32.44-35 32.44c-22.19 0-54-27.42-54-27.42l9.76-22.77 38.26 10.8Z"
      style={{
        fill: '#37474f',
      }}
    />
    <path
      d="M396.72 247a81.38 81.38 0 0 1-.38-20.27c.72-6.76 1.52-15 1.52-18.3.15-9.38-4.18-20.66-9.56-23.62l-7.69 1.41-17.14 4.78-8 1.66s-15.7 15.32-15.7 33.29a10.88 10.88 0 0 0 .26 2.3l.05.07c1.47 6.63 8.41 11.24 8.41 11.24a87.45 87.45 0 0 1 1 13.78 31.81 31.81 0 0 1-2.85 13.78s6.4 14.51 25.75 14.51c13.33 0 24.05-9.49 27.28-14.8Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M396.72 247a81.38 81.38 0 0 1-.38-20.27c.72-6.76 1.52-15 1.52-18.3.15-9.38-4.18-20.66-9.56-23.62l-7.69 1.41-17.14 4.78-8 1.66s-15.7 15.32-15.7 33.29a10.88 10.88 0 0 0 .26 2.3l.05.07c1.47 6.63 8.41 11.24 8.41 11.24a87.45 87.45 0 0 1 1 13.78 31.81 31.81 0 0 1-2.85 13.78s6.4 14.51 25.75 14.51c13.33 0 24.05-9.49 27.28-14.8Z"
      style={{
        opacity: 0.5,
      }}
    />
    <path
      d="M376.47 191.18c-5.88 1.88-13-.19-13-.19v-19.88h17v16.06a5.9 5.9 0 0 1-4 4.01Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M349.81 158.25v9.42l-5.52-1.69 5.52-7.73z"
      style={{
        fill: '#f28f8f',
      }}
    />
    <path
      d="M378.89 133.71c-3.68-1-16.52-3.57-27.94 6-2.53 2.11-5.42 7.73-6.35 14.75a19.21 19.21 0 0 0 4.67 2.52Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M370.85 137.58c-5.61-.61-17.89 1.2-20.88 15.74s-2.92 26.07 4.54 28 25.66-1.62 30.1-20.37-8.29-22.76-13.76-23.37Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M355.33 141.12s-1.94 7.62 1 13.59a12.39 12.39 0 0 1 .65 9.9 14.76 14.76 0 0 1-2.58 4.46s4-.7 5.72-5.87a40 40 0 0 1 2.93 8.74c.51 3.57 2.65 6.58 9.3 8.42 3.24.9 7.37.48 9.5-.84 0 0 6.52-4.44 9.14-8.07s8.27-16.51 2.4-26.6-20.74-18.52-38.06-3.73Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M362.6 169.76s-.27 7.5-2.23 11.78-5.85 14.41 5 18c0 0-2.65-3.77-.67-6.24 0 0 10.45 13.44 25.35.89 0 0-4.72-1.24-5.66-5.09 0 0 11.62 10.57 18.92-4.23 0 0-12.55-9-8.8-20.79Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M360.58 163.2s.74-6.18 5-6.25c4.72-.06 5.3 4.49 5.21 6.11-.22 4.24-2.8 8.38-10.25 6Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M355.33 141.12s-4.95 3.7-4.12 16.42c0 0 2.91 1.43 5.13 1 0 0-.5-6.88 2.22-12.21Z"
      style={{
        fill: '#263238',
      }}
    />
    <path
      d="M277.2 198.85s-1.19-2.93-1.71-4.37a25.94 25.94 0 0 0-2.55-5.17l-6.48.79s-4.48-2.45-6.75-5.21-6.57-6.52-7.88-3.69-1.43 11.56.38 14.16 5.58 7.62 15.07 12.38Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="m329.24 202.49-24.72 10.32-27.32-14s-9.92 1.48-9.92 8.89c0 0 24.54 18.71 32.45 23.41s49.34-16.22 49.34-16.22Z"
      style={{
        fill: '#ffa8a7',
      }}
    />
    <path
      d="M324.82 203.39a23 23 0 0 0 6.48 20.35s31.36-8.81 28.73-23.88c-1.09-6.24-4.56-7.21-4.56-7.21s-2.93-1.15-14.31 3.71-16.34 7.03-16.34 7.03Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M324.82 203.39a23 23 0 0 0 6.48 20.35s31.36-8.81 28.73-23.88c-1.09-6.24-4.56-7.21-4.56-7.21s-2.93-1.15-14.31 3.71-16.34 7.03-16.34 7.03Z"
      style={{
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M299.6 284.83V292c0 1.2 0 5.63 7.92 12s25.57 17.46 33.52 18.6c18.46 2.65 26.13-64.89 46.55-81.29 17.44-14 27.25-13.36 27.25-13.36a16.69 16.69 0 0 0-3.47-2.31c-4.12-2.11-35 6.21-44.91 40.89-2.62 9.19-13.64 40.83-20.34 47.84s-21.26-4.09-36.62-14.53c-6.44-4.39-9.9-9.31-9.9-15.01Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
    <path
      d="M299.6 284.83V292c0 1.2 0 5.63 7.92 12s25.57 17.46 33.52 18.6c18.46 2.65 26.13-64.89 46.55-81.29 17.44-14 27.25-13.36 27.25-13.36a16.69 16.69 0 0 0-3.47-2.31c-4.12-2.11-35 6.21-44.91 40.89-2.62 9.19-13.64 40.83-20.34 47.84s-21.26-4.09-36.62-14.53c-6.44-4.39-9.9-9.31-9.9-15.01Z"
      style={{
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="M414.84 227.94s-9.81-.64-27.25 13.36c-20.42 16.4-28.09 83.94-46.55 81.29 10.85 4.11 31.27-7.77 50.3-17.77s19.89-13.56 24-30.54c8.86-36.36 2.76-44.12-.5-46.34Z"
      style={{
        fill: '#0c0c0c',
      }}
    />
  </svg>
);
export default React.memo(ArchitechIllustration);
